module.exports = __webpack_public_path__ + "static/36-3c0cf6f608a96cd8b1b72270d19446c3.jpg";